import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_pgw_txn_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  foreign_ccy:boolean;
  base_txn_guid: fromDatatype.VarcharDatatypeInterface;
  base_txn_ccy: fromDatatype.VarcharDatatypeInterface;
  base_txn_xrate: fromDatatype.NumericDatatypeInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  txn_reference: fromDatatype.VarcharDatatypeInterface;
  txn_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  txn_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  txn_entity_line_guid: fromDatatype.VarcharDatatypeInterface;
  txn_entity_line_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  gst_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_tax_num: fromDatatype.VarcharDatatypeInterface;
  gst_entity_type: fromDatatype.VarcharDatatypeInterface;
  gst_entity_contact_json: fromDatatype.JsonDatatypeInterface;
  display_entity_json: fromDatatype.JsonDatatypeInterface;
  delivery_entity_json: fromDatatype.JsonDatatypeInterface;
  foreign_references_json: fromDatatype.JsonDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status_client: fromDatatype.VarcharDatatypeInterface;
  status_server: fromDatatype.VarcharDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  credit_terms_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  entity_merchant_key: fromDatatype.VarcharDatatypeInterface;
  entity_merchant_code: fromDatatype.VarcharDatatypeInterface;
  merchant_ref_no: fromDatatype.VarcharDatatypeInterface;
  request_txn_items: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  merchant_code_company: fromDatatype.VarcharDatatypeInterface;
  pgw_code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  request_txn_merchant_code: fromDatatype.VarcharDatatypeInterface;
  request_txn_payment_id: fromDatatype.VarcharDatatypeInterface;
  request_txn_ref_no: fromDatatype.VarcharDatatypeInterface;
  request_txn_amount: fromDatatype.VarcharDatatypeInterface;
  request_txn_ccy: fromDatatype.VarcharDatatypeInterface;
  request_txn_descr: fromDatatype.VarcharDatatypeInterface;
  request_txn_username: fromDatatype.VarcharDatatypeInterface;
  request_txn_user_email: fromDatatype.VarcharDatatypeInterface;
  request_txn_user_contact: fromDatatype.VarcharDatatypeInterface;
  request_txn_remark: fromDatatype.VarcharDatatypeInterface;
  request_txn_lang: fromDatatype.VarcharDatatypeInterface;
  request_txn_signature_type: fromDatatype.VarcharDatatypeInterface;
  request_txn_signature: fromDatatype.VarcharDatatypeInterface;
  request_txn_response_url: fromDatatype.VarcharDatatypeInterface;
  request_txn_backend_url: fromDatatype.VarcharDatatypeInterface;
  response_txn_merchant_code: fromDatatype.VarcharDatatypeInterface;
  response_txn_payment_id: fromDatatype.VarcharDatatypeInterface;
  response_txn_ref_no: fromDatatype.VarcharDatatypeInterface;
  response_txn_amount: fromDatatype.VarcharDatatypeInterface;
  response_txn_ccy: fromDatatype.VarcharDatatypeInterface;
  response_txn_remark: fromDatatype.VarcharDatatypeInterface;
  response_txn_trans_id: fromDatatype.VarcharDatatypeInterface;
  response_txn_auth_code: fromDatatype.VarcharDatatypeInterface;
  response_txn_status: fromDatatype.VarcharDatatypeInterface;
  response_txn_err_descr: fromDatatype.VarcharDatatypeInterface;
  response_txn_signature: fromDatatype.VarcharDatatypeInterface;
  response_txn_cc_name: fromDatatype.VarcharDatatypeInterface;
  response_txn_cc_no: fromDatatype.VarcharDatatypeInterface;
  response_txn_s_bankname: fromDatatype.VarcharDatatypeInterface;
  response_txn_s_country: fromDatatype.VarcharDatatypeInterface;
  merchant_key: fromDatatype.VarcharDatatypeInterface;
  success_page_url: fromDatatype.VarcharDatatypeInterface;
  fail_page_url: fromDatatype.VarcharDatatypeInterface;
  server_direct_url: fromDatatype.VarcharDatatypeInterface;
  server_indirect_url: fromDatatype.VarcharDatatypeInterface;
  contract_key: fromDatatype.VarcharDatatypeInterface;
  indirect_status: fromDatatype.VarcharDatatypeInterface;
  direct_status: fromDatatype.VarcharDatatypeInterface;
  summary_status: fromDatatype.VarcharDatatypeInterface;
  payment_channel_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_pgw_txn_RowClass implements bl_fi_generic_doc_pgw_txn_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  foreign_ccy:boolean;
  base_txn_guid: fromDatatype.VarcharDatatypeInterface;
  base_txn_ccy: fromDatatype.VarcharDatatypeInterface;
  base_txn_xrate: fromDatatype.NumericDatatypeInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  txn_reference: fromDatatype.VarcharDatatypeInterface;
  txn_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  txn_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  txn_entity_line_guid: fromDatatype.VarcharDatatypeInterface;
  txn_entity_line_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  gst_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_tax_num: fromDatatype.VarcharDatatypeInterface;
  gst_entity_type: fromDatatype.VarcharDatatypeInterface;
  gst_entity_contact_json: fromDatatype.JsonDatatypeInterface;
  display_entity_json: fromDatatype.JsonDatatypeInterface;
  delivery_entity_json: fromDatatype.JsonDatatypeInterface;
  foreign_references_json: fromDatatype.JsonDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status_client: fromDatatype.VarcharDatatypeInterface;
  status_server: fromDatatype.VarcharDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  credit_terms_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  entity_merchant_key: fromDatatype.VarcharDatatypeInterface;
  entity_merchant_code: fromDatatype.VarcharDatatypeInterface;
  merchant_ref_no: fromDatatype.VarcharDatatypeInterface;
  request_txn_items: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  merchant_code_company: fromDatatype.VarcharDatatypeInterface;
  pgw_code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  request_txn_merchant_code: fromDatatype.VarcharDatatypeInterface;
  request_txn_payment_id: fromDatatype.VarcharDatatypeInterface;
  request_txn_ref_no: fromDatatype.VarcharDatatypeInterface;
  request_txn_amount: fromDatatype.VarcharDatatypeInterface;
  request_txn_ccy: fromDatatype.VarcharDatatypeInterface;
  request_txn_descr: fromDatatype.VarcharDatatypeInterface;
  request_txn_username: fromDatatype.VarcharDatatypeInterface;
  request_txn_user_email: fromDatatype.VarcharDatatypeInterface;
  request_txn_user_contact: fromDatatype.VarcharDatatypeInterface;
  request_txn_remark: fromDatatype.VarcharDatatypeInterface;
  request_txn_lang: fromDatatype.VarcharDatatypeInterface;
  request_txn_signature_type: fromDatatype.VarcharDatatypeInterface;
  request_txn_signature: fromDatatype.VarcharDatatypeInterface;
  request_txn_response_url: fromDatatype.VarcharDatatypeInterface;
  request_txn_backend_url: fromDatatype.VarcharDatatypeInterface;
  response_txn_merchant_code: fromDatatype.VarcharDatatypeInterface;
  response_txn_payment_id: fromDatatype.VarcharDatatypeInterface;
  response_txn_ref_no: fromDatatype.VarcharDatatypeInterface;
  response_txn_amount: fromDatatype.VarcharDatatypeInterface;
  response_txn_ccy: fromDatatype.VarcharDatatypeInterface;
  response_txn_remark: fromDatatype.VarcharDatatypeInterface;
  response_txn_trans_id: fromDatatype.VarcharDatatypeInterface;
  response_txn_auth_code: fromDatatype.VarcharDatatypeInterface;
  response_txn_status: fromDatatype.VarcharDatatypeInterface;
  response_txn_err_descr: fromDatatype.VarcharDatatypeInterface;
  response_txn_signature: fromDatatype.VarcharDatatypeInterface;
  response_txn_cc_name: fromDatatype.VarcharDatatypeInterface;
  response_txn_cc_no: fromDatatype.VarcharDatatypeInterface;
  response_txn_s_bankname: fromDatatype.VarcharDatatypeInterface;
  response_txn_s_country: fromDatatype.VarcharDatatypeInterface;
  merchant_key: fromDatatype.VarcharDatatypeInterface;
  success_page_url: fromDatatype.VarcharDatatypeInterface;
  fail_page_url: fromDatatype.VarcharDatatypeInterface;
  server_direct_url: fromDatatype.VarcharDatatypeInterface;
  server_indirect_url: fromDatatype.VarcharDatatypeInterface;
  contract_key: fromDatatype.VarcharDatatypeInterface;
  indirect_status: fromDatatype.VarcharDatatypeInterface;
  direct_status: fromDatatype.VarcharDatatypeInterface;
  summary_status: fromDatatype.VarcharDatatypeInterface;
  payment_channel_code: fromDatatype.VarcharDatatypeInterface;
}
